import { motion, useScroll, useSpring } from "framer-motion";

/**
 * Thin gradient progress bar that fills as the page scrolls. Sits just under
 * the fixed navbar.
 */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 z-[60] h-[3px] origin-left bg-gradient-to-r from-orange-500 via-orange-400 to-sky-400"
    />
  );
}
